// ===== Swiper imports (npm) =====
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Swiper.use([Navigation, Pagination, Autoplay]);

const DESKTOP_WIDTH = 1440;

/* ======================================================
   ADVANTAGES
   mobile → tablet → desktop(до 1439): slider
   1440+: 3 slides (slider OK)
====================================================== */
const advantagesSwiper = new Swiper('.advantages-swiper', {
  slidesPerView: 1,
  spaceBetween: 16,
  speed: 600,
  loop: true,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },

  navigation: {
    nextEl: '.advantages-next',
    prevEl: '.advantages-prev',
  },

  breakpoints: {
    1440: {
      slidesPerView: 3,
    },
  },
});

/* ======================================================
   REVIEWS
   0–1439: slider
   1440+: destroy
====================================================== */
let reviewsSwiper = null;

function initReviewsSwiper() {
  if (window.innerWidth < DESKTOP_WIDTH && !reviewsSwiper) {
    reviewsSwiper = new Swiper('.reviews-swiper', {
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 20,
      speed: 500,
      loop: true,

      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },

      pagination: {
        el: '.reviews-pagination',
        clickable: true,
      },
    });
  }

  if (window.innerWidth >= DESKTOP_WIDTH && reviewsSwiper) {
    reviewsSwiper.destroy(true, true);
    reviewsSwiper = null;
  }
}

/* ======================================================
   SIMILAR
   0–1439: slider
   1440+: destroy
====================================================== */
let similarSwiper = null;

function initSimilarSwiper() {
  if (window.innerWidth < DESKTOP_WIDTH && !similarSwiper) {
    similarSwiper = new Swiper('.similar-swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 500,
      loop: true,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },

      navigation: {
        nextEl: '.similar-next',
        prevEl: '.similar-prev',
      },
    });
  }

  if (window.innerWidth >= DESKTOP_WIDTH && similarSwiper) {
    similarSwiper.destroy(true, true);
    similarSwiper = null;
  }
}

/* ======================================================
   INIT
====================================================== */
function initSwipers() {
  initReviewsSwiper();
  initSimilarSwiper();
}

window.addEventListener('load', initSwipers);
window.addEventListener('resize', initSwipers);
